import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IsApprove from "@/components/management/serve/IsApprove"; // 审批类 站内组件

import IsSearch from "@/components/management/serve/IsSearch"; // 查询类 站内组件

import IsOther from "@/components/management/serve/IsOther"; // 公用站外组件

export default {
  name: "Dialog",
  components: {
    IsApprove: IsApprove,
    // 审批类
    IsSearch: IsSearch,
    // 查询类
    IsOther: IsOther // 其他

  },
  props: ["propData"],
  data: function data() {
    return {
      show: false,
      loading: false,
      disabled: false,
      title: "",
      serveId: "",
      // 关联到下级组件
      selectType: {
        // 服务类型
        data: []
      },
      selectObj: {
        data: []
      },
      selectTheme: {
        data: []
      },
      selectModule: {
        data: []
      },
      form: {
        serveType: "0",
        moduleType: "all"
      },
      moduleDisabled: false,
      // 服务模板选择是否禁用
      prorData: {},
      backData: null,
      infoFrom: {} // 保存 详情的变量

    };
  },
  computed: {
    // 判断 根据选择的类别 调用不同组件
    // IsApprove : 审批类
    // IsSearch  : 查询类
    // IsOther   : 其他
    // serveType: 0: 查询类; 1:审批类; 9: 其他
    componentName: function componentName() {
      var _this = this; // 传之组件


      _this.prorData = {
        serveId: _this.serveId,
        obj: _this.selectObj.data,
        theme: _this.selectTheme.data,
        infoFrom: _this.infoFrom
      }; // 详情的时候

      if (_this.serveId !== "") {
        if (_this.form.serveType === "0") {
          _this.moduleDisabled = true;
          return "IsSearch";
        } else if (_this.form.serveType === "1") {
          _this.moduleDisabled = true;
          return "IsApprove";
        } else {
          _this.moduleDisabled = true;
          return "IsOther";
        }
      } else {
        // 新增
        if (_this.form.serveType === "0") {
          _this.moduleDisabled = false;
          return "IsSearch";
        } else if (_this.form.serveType === "1") {
          _this.moduleDisabled = false;
          return "IsApprove";
        } else {
          _this.moduleDisabled = true;
          return "IsOther";
        }
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.initFn();
  },
  destroyed: function destroyed() {},
  methods: {
    // 默认请求
    // 请求子组件用到的公用接口
    initFn: function initFn() {
      this.getServeType(); // 服务类型

      this.getServeObj(); // 服务对象

      this.getServeTheme(); // 服务主题

      this.getServeModule(this.form.serveType); // 服务组件
      // 传之组件

      this.prorData = {
        serveId: this.serveId,
        obj: this.selectObj.data,
        theme: this.selectTheme.data,
        infoFrom: this.infoFrom
      };
    },
    // 切换 服务类型
    changeServeModule: function changeServeModule(type) {
      this.form.moduleType = "all";
      this.getServeModule(type);
    },
    // 显示弹框
    dialogShow: function dialogShow(id, name, type) {
      var _this2 = this;

      this.show = true;
      this.loading = true;
      this.form.serveType = type; // 清空 详情对象

      this.infoFrom = {};
      setTimeout(function () {
        if (id) {
          _this2.title = name + "详情";

          _this2.getInfoData(id, name);

          _this2.disabled = true;
          _this2.moduleDisabled = true;
        } else {
          _this2.title = "新增服务";
          _this2.serveId = "";
          _this2.disabled = false; // 调用刷新表单方法

          _this2.$refs.formRule.refreshForm();
        }

        _this2.loading = false;
      }, 500);
    },
    // 服务类型
    getServeType: function getServeType() {
      var _this3 = this;

      this.$http.get("/hallServe/typeList").then(function (res) {
        res.data.resData.forEach(function (e) {
          _this3.selectType.data.push({
            value: e.id + "",
            label: e.serveTypeName
          });
        });
      }).catch(function () {
        _this3.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 服务对象
    getServeObj: function getServeObj() {
      var _this4 = this;

      this.$http.get("/hallServe/targetList").then(function (res) {
        res.data.resData.forEach(function (e) {
          _this4.selectObj.data.push({
            value: e.id + "",
            label: e.targetTypeName
          });
        });
      }).catch(function () {
        _this4.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 服务主题
    getServeTheme: function getServeTheme() {
      var _this5 = this;

      var data = this.$qs.stringify({
        // 传入参数
        subjectName: "",
        pageNum: 0,
        pageSize: 999
      });
      this.$http.post("/subject/subjectPageList", data).then(function (res) {
        res.data.resData.list.forEach(function (e) {
          _this5.selectTheme.data.push({
            value: e.id + "",
            label: e.subjectName
          });
        });
      }).catch(function () {
        _this5.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 服务组件 form.serveType = 0; 查询类 form.serveType = 1 审批类 组件
    getServeModule: function getServeModule(type) {
      var _this6 = this;

      this.selectModule.data = [];
      this.$http.get("/hallServe/componentList?componentType=" + type).then(function (res) {
        res.data.resData.forEach(function (e) {
          _this6.selectModule.data.push({
            value: e.id + "",
            label: e.interfaceUrl
          });
        });
      }).catch(function () {
        _this6.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 保存（根据子组件信息调用）
    // 1、backData 中包含有 formType => one: 查询类 站内; two: 审批类站内; three: 站外
    // 2、保存成功之后，会生成一个 服务id:serveId;
    // 3、子组件操作中，如果 有 serveId; 此时的保存，应该调用 更新的接口
    getChildData: function getChildData(backData) {
      var _this7 = this;

      var arrObj = []; // 服务对象

      var arrTheme = []; // 服务主题
      // 转换 服务对象

      backData.obj.forEach(function (e) {
        _this7.selectObj.data.forEach(function (i) {
          if (e === i.value) {
            arrObj.push({
              id: e,
              targetName: i.label
            });
          }
        });
      }); // 转换 服务主题

      backData.theme.forEach(function (e) {
        _this7.selectTheme.data.forEach(function (i) {
          if (e === i.value) {
            arrTheme.push({
              id: e,
              subjectName: i.label
            });
          }
        });
      }); // 保存 第一项信息

      var data = this.$qs.stringify({
        // 传入参数
        serveName: backData.name,
        serveType: this.form.serveType,
        serveSubject: JSON.stringify(arrTheme),
        serveTarget: JSON.stringify(arrObj),
        componentId: this.form.moduleType === "all" ? "" : this.form.moduleType,
        recommend: backData.recommend === true ? 1 : 0,
        linkUrl: backData.linkUrl,
        mobileUrl: backData.mobileUrl,
        terminal: backData.terminal.join(","),
        fileId: backData.imgId,
        processDefId: backData.processDefId,
        processVersionId: backData.processVersionId,
        id: this.serveId
      }); // 如果存在 this.serveId,此时点击 保存，调用的是更新的方法

      if (this.serveId !== "") {
        this.updateServe(data, backData.formType);
        return;
      }

      this.$http.post("/hallServe/addServe", data).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this7.$message.success("服务基本信息保存成功！");

          _this7.$nextTick(function () {
            _this7.serveId = data.resData;
          }); // 没有其他提交，则关闭窗口、刷新列表


          if (backData.formType !== "one") {
            _this7.show = false;
            _this7.serveId = "";
            _this7.infoFrom = {};
          }

          _this7.$parent.initPage();
        }
      }).catch(function () {
        _this7.$message.error("网络错误，服务基本信息保存接口请求失败！");
      });
    },
    // 更新
    updateServe: function updateServe(data, type) {
      var _this8 = this;

      this.$http.post("/hallServe/updateServe", data).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode === 0) {
          _this8.$message.success("服务基本信息更新成功！"); // 没有使用说明提交，则关闭窗口、刷新列表


          if (type !== "one") {
            _this8.show = false;
            _this8.serveId = "";
            _this8.infoFrom = {};
          }

          _this8.$parent.initPage();
        }
      }).catch(function () {
        _this8.$message.error("网络错误，服务基本信息更新接口请求失败！");
      });
    },
    // 点击 保存
    submitForm: function submitForm() {
      // 调用验证方法
      this.$refs.formRule.validateForm("ruleForm");
    },
    // 子组件关闭窗口
    closeDialog: function closeDialog() {
      this.show = false;
      this.$emit("closeFn");
    },
    // 关闭大窗口
    closeBox: function closeBox() {
      this.show = false;
      this.serveId = "";
      this.infoFrom = {};
    },
    // 获取详情
    getInfoData: function getInfoData(id) {
      var _this9 = this;

      this.$http.get("/hallServe/serveDetail?serveId=" + id).then(function (_ref3) {
        var data = _ref3.data;

        if (data.resCode === 0) {
          var obj = [];
          var theme = [];
          var logoData = data.resData.logo;
          var serveData = data.resData.serve;
          serveData.serveTargetList.forEach(function (e) {
            obj.push(e.id + "");
          });
          serveData.serveSubjectList.forEach(function (e) {
            theme.push(e.id);
          });

          if (logoData) {
            _this9.infoFrom.imgUrl = logoData.fileUrl;
            _this9.infoFrom.imgId = logoData.id;
            _this9.infoFrom.recommend = serveData.recommend === 1 ? true : false;
            _this9.infoFrom.serveId = serveData.id;
            _this9.infoFrom.formType = serveData.serveType === "0" ? "two" : serveData.serveType === "1" ? "one" : "three";
            _this9.infoFrom.name = serveData.serveName;
            _this9.infoFrom.obj = obj;
            _this9.infoFrom.theme = theme;
            _this9.infoFrom.processDefId = serveData.processDefId; // 服务Id

            _this9.infoFrom.processVersionId = serveData.processVersionId; // 流程版

            _this9.infoFrom.linkUrl = serveData.linkUrl;
            _this9.infoFrom.mobileUrl = serveData.mobileUrl;
            _this9.infoFrom.terminal = serveData.terminal;
            _this9.form.serveType = serveData.serveType;
            _this9.form.moduleType = serveData.componentId === "" ? "all" : serveData.componentId;
            _this9.serveId = serveData.id;
          }
        }
      }).catch(function () {
        _this9.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 调用子组件下的保存方法
    clickChildFn: function clickChildFn() {
      this.$refs.formRule.clickChildFn();
    }
  },
  watch: {
    infoFrom: {
      handler: function handler() {
        // 传之组件
        this.prorData = {
          serveId: this.serveId,
          obj: this.selectObj.data,
          theme: this.selectTheme.data,
          infoFrom: this.infoFrom
        };
      },
      immediate: true
    }
  },
  filters: {}
};